import { useCallback, useState } from 'react';

export const useToggle = (initialState = false) => {
  const [isOpen, setIsDrawerOpen] = useState(initialState);

  const open = useCallback(() => {
    setIsDrawerOpen(true);
  }, []);

  const close = useCallback(() => {
    setIsDrawerOpen(false);
  }, []);

  return { close, isOpen, open };
};
